import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ClientProfile } from "../../../interfaces/common";
import { NameNumberInterface } from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import TextLink from "../../../components/TextLink";

import ChevronLeftIcon from "../../../components/Icons/ChevronLeftIcon";

interface Props {
  profile: ClientProfile;
  save: Function;
  goBack: Function;
}

const StepTwo: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const [coachingExperience, setCoachingExperience] = useState<number>(
    props.profile.coachingExperience
  );
  const experiences: Array<NameNumberInterface> = [
    { name: "vast-experience", value: 3 },
    { name: "moderate-experience", value: 2 },
    { name: "little-experience", value: 1 },
    { name: "no-experience", value: 0 },
  ];

  const notValid = () => {
    return coachingExperience < 0;
  };

  const save = () => {
    const newProfile: ClientProfile = props.profile;
    newProfile.coachingExperience = coachingExperience;
    props.save(newProfile);
  };

  return (
    <div className="flex flex-col gap-6 mt-6">
      <div className="z-heading2">{t("coach-experience-title")}</div>
      <div className="">
        <div>{t("coach-experience-subtitle")}</div>
        <div className="mt-2">
          {experiences.map((experience) => (
            <div
              className="flex items-center mt-4 cursor-pointer"
              key={"exp_" + experience.value}
              onClick={() => setCoachingExperience(experience.value)}
            >
              <div className="z-radiobox">
                {experience.value === coachingExperience && (
                  <div className="rounded-full bg-gray-100 w-4 h-4" />
                )}
              </div>
              <div className="ml-2">{t(experience.name)}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <CustomButton
          disabled={notValid()}
          className="mt-6"
          onClick={() => save()}
        >
          {t("next")}
        </CustomButton>

        {/* Back Link */}

        <TextLink
          color="white"
          onClick={() => props.goBack()}
          leftIcon={<ChevronLeftIcon className="h-4 w-4 text-white!" aria-hidden="true" />}
          size="sm"
        >
          {t("back")}
        </TextLink>
      </div>
    </div>
  );
};

export default StepTwo;
